module.exports = __webpack_public_path__ + "static/media/image-card-2.b90f2899.png";